// Converts the given date from UTC to local time
import { zonedTimeToUtc } from "date-fns-tz";

const convertFromUTC = (time: any, timeZone: string, showAmPm: boolean = true) => {
  if (!time) return "";
  
  try {
    const date = new Date(time);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      console.warn(`[convertFromUTC] Invalid date: ${time}`);
      return String(time); // Return the raw string if invalid
    }

    const options: Intl.DateTimeFormatOptions = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: showAmPm, 
      timeZone: timeZone,
    }; 

    const localTime = date.toLocaleTimeString([], options);

    return localTime;
  } catch (error) {
    console.error(`[convertFromUTC] Error converting date: ${time}`, error);
    return String(time); // Fallback to raw string
  }
};

const convertToUTC = (date: any, time: string, timeZone: any) => {
  try {
    const dateTime = `${date}T${time}:00`;
    const utcDate = zonedTimeToUtc(dateTime, timeZone);
    
    // Validate the result
    if (isNaN(utcDate.getTime())) {
      console.warn(`[convertToUTC] Invalid date result: ${dateTime}`);
      return dateTime; // Return original if conversion fails
    }
    
    return utcDate.toISOString(); // Return the UTC time in ISO format
  } catch (error) {
    console.error(`[convertToUTC] Error converting date: ${date} ${time}`, error);
    return `${date}T${time}:00`; // Fallback to original format
  }
};

export { convertFromUTC, convertToUTC };